module.exports = __webpack_public_path__ + "img/main-head.fee438df.png";